import Relay from 'react-relay';
/**
*  Update locker mutation
*/
export default class UpdateLockerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      updateLocker
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lockerId: this.props.lockerId,
        locker: {
            ...this.props.locker
        }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateLockerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        locker {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            infrastructures {
                id
            }
            externalId,
            accessControl {
              enableNoAccessControl,
              automaticNoAccessControl {
                  monday {
                      from, 
                      to
                  },
                  tuesday {
                      from, 
                      to
                  },
                  wednesday {
                      from, 
                      to
                  },
                  thursday {
                      from, 
                      to
                  },
                  friday {
                      from, 
                      to
                  },
                  saturday {
                      from, 
                      to
                  },
                  sunday {
                      from, 
                      to
                  }
              }
            }
        }
      }
    `;
  }

  /**
  *  Config
  */
 getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/UpdateLockerMutation.js